import emailjs from '@emailjs/browser';

// EmailJS configuration
// Option 1: Use environment variables (recommended for production)
// Create a .env file in the root directory with:
// REACT_APP_EMAILJS_SERVICE_ID=your_service_id
// REACT_APP_EMAILJS_TEMPLATE_ID_HOMEPAGE=your_homepage_template_id
// REACT_APP_EMAILJS_TEMPLATE_ID_CONTACT=your_contact_template_id
// REACT_APP_EMAILJS_PUBLIC_KEY=your_public_key

// Option 2: Replace these directly (for quick setup)
const EMAILJS_SERVICE_ID = process.env.REACT_APP_EMAILJS_SERVICE_ID || 'YOUR_SERVICE_ID';
const EMAILJS_TEMPLATE_ID_HOMEPAGE = process.env.REACT_APP_EMAILJS_TEMPLATE_ID_HOMEPAGE || 'YOUR_HOMEPAGE_TEMPLATE_ID';
const EMAILJS_TEMPLATE_ID_CONTACT = process.env.REACT_APP_EMAILJS_TEMPLATE_ID_CONTACT || 'YOUR_CONTACT_TEMPLATE_ID';
const EMAILJS_PUBLIC_KEY = process.env.REACT_APP_EMAILJS_PUBLIC_KEY || 'YOUR_PUBLIC_KEY';

// Initialize EmailJS with public key
if (EMAILJS_PUBLIC_KEY && EMAILJS_PUBLIC_KEY !== 'YOUR_PUBLIC_KEY') {
  emailjs.init(EMAILJS_PUBLIC_KEY);
}

/**
 * Send email from homepage demo form
 * @param {Object} formData - Form data object
 * @returns {Promise} EmailJS send promise
 */
export const sendHomepageDemoEmail = async (formData) => {
  try {
    const templateParams = {
      from_name: `${formData.firstName} ${formData.lastName}`,
      from_email: formData.email,
      company: formData.company,
      energy_capacity: formData.energyCapacity,
      to_name: 'AxonMetric Team',
      message: `
        New Demo Request from Homepage
        
        Name: ${formData.firstName} ${formData.lastName}
        Email: ${formData.email}
        Company: ${formData.company}
        Energy Portfolio Size: ${formData.energyCapacity}
        
        Please contact them to schedule a demo.
      `
    };

    const response = await emailjs.send(
      EMAILJS_SERVICE_ID,
      EMAILJS_TEMPLATE_ID_HOMEPAGE,
      templateParams
    );

    return { success: true, response };
  } catch (error) {
    console.error('EmailJS Error:', error);
    throw error;
  }
};

/**
 * Send email from contact page form
 * @param {Object} formData - Form data object
 * @returns {Promise} EmailJS send promise
 */
export const sendContactEmail = async (formData) => {
  try {
    const templateParams = {
      from_name: formData.name,
      from_email: formData.email,
      company: formData.company || 'Not provided',
      phone: formData.phone || 'Not provided',
      subject: formData.subject || 'General Inquiry',
      message: formData.message,
      to_name: 'AxonMetric Team'
    };

    const response = await emailjs.send(
      EMAILJS_SERVICE_ID,
      EMAILJS_TEMPLATE_ID_CONTACT,
      templateParams
    );

    return { success: true, response };
  } catch (error) {
    console.error('EmailJS Error:', error);
    throw error;
  }
};

